import React, { useEffect, useState } from "react";
import HttpService from "../../HttpService";

import _ from "lodash";

import OwlCarousel from "react-owl-carousel2";
import Loader from "../../components/Loader/Loader";
import { Search } from "semantic-ui-react";
import Add from "../../assets/img/ad.png";
import AdComponent from "../../components/AdComponent";
import AddGif from "../../assets/img/ad.gif";
import { useHistory } from "react-router-dom";
import ProductBox from "../../components/ProductBox/ProductBox";
import ProductDetailsModal from "../../components/Modal/ProductDetailsModal";
import ProductBoxMultiple from "../../components/ProductBox/ProductBoxMultiple";
const Home = () => {
  const history = useHistory();
  const [productList, setProductList] = useState([]);
  const [productModal, setProductDataModal] = useState([]);
  const [products, setProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [value, setValue] = useState("");
  const [banners, setBanner] = useState([]);
  const [bannerLoader, setBannerLoader] = useState(false);
  const [loadingCategories, setCategoriesLoading] = useState(false);
  const [compareLoading, setCompareLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [productListLoading, setProductListLoading] = useState(false);
  const options = {
    loop: true,
    nav: true,
    margin: 10,
    rewind: true,
    autoplay: true,

    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },

      1000: {
        items: 3,
      },
    },
  };

  const options2 = {
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 2,
      },
    },
  };

  useEffect(() => {
    const fetchProducts = async () => {
      setError(false);
      setBannerLoader(true);
      setCategoriesLoading(true);
      setCompareLoading(true);
      setProductListLoading(true);
      try {
        const categories = await HttpService.get("/categories");
        setCategories(categories.data);
        setCategoriesLoading(false);
        const featuredProducts = await HttpService.get("/featured/products");
        setCompareLoading(false);
        setFeaturedProducts(featuredProducts.data);

        const products = await HttpService.get("/products");
        setProducts(products && products.data && products.data.products);
        // const productList = await HttpService.get("/products");
        setProductOptions(
          products.data.products.map((product) => ({
            title: product.name,
            // description: "description",
            image: product.image,
            company_name: product.company_name,
            price: `Price : ${product.price}`,
            productDetails: product.productDetails,
            _id: product._id,
            key: product._id,
          }))
        );
      } catch (error) {
        setError(true);
      }

      setProductListLoading(false);
    };

    fetchProducts();
  }, []);

  const handlePriceCategory = async (e, range1, range2) => {
    e.preventDefault();

    history.push({
      pathname: "/products",

      state: {
        priceRange1: range1,
        priceRange2: range2,
      },
    });
  };

  const setProductModal = (product) => {
    setProductDataModal(product);
  };

  const navigateCompanyProducts = (name) => {
    history.push({
      pathname: "/products",

      state: { companyName: name, sponsoredName: name.toLowerCase() },
    });
  };

  const comparehandler = (product) => {
    history.push({
      pathname: "/compareProducts",

      state: { products: [product] },
    });
  };

  const comparehandlerMultiple = (product) => {
    history.push({
      pathname: "/compareProducts",

      state: { products: product },
    });
  };

  const handleSearchChange = (e, { value }) => {
    setTimeout(() => {
      if (value.length < 1) {
        setValue(value);
        setProductList([]);
      }
      const re = new RegExp(_.escapeRegExp(value), "i");

      const isMatch = (result) => re.test(result.title);
      const results = _.filter(productOptions, isMatch);

      if (results.length > 0) {
        setProductList(results);
      } else {
        const isMatch = (result) => re.test(result.company_name);
        const results = _.filter(productOptions, isMatch);
        setProductList(results);
      }
    }, 300);
  };

  const handleResultSelect = async (e, data) => {
    let products = [];
    const product = await HttpService.get(`/product/${data.result._id}`);
    products = [...selectedProduct];
    products[data.index] = product.data;
    setSelectedProduct(products);
  };

  const getFeaturedCompare = (index) => {
    if (index < 1) {
      return (
        <OwlCarousel options={options2} responsive={true}>
          {featuredProducts &&
            featuredProducts.map((product) => {
              return (
                <ProductBoxMultiple
                  product={product}
                  comparehandler={comparehandlerMultiple}
                />
              );
            })}
        </OwlCarousel>
      );
    }
  };
  const getTrendingProduct = (category, displayCategory) => {
    return (
      <OwlCarousel options={options} responsive={true}>
        {category &&
          category.products.map((product) => {
            return (
              <div>
                <ProductBox
                  width={100}
                  product={product}
                  comparehandler={comparehandler}
                  setProductModal={setProductModal}
                />
              </div>
            );
          })}
      </OwlCarousel>
    );
  };

  const getFeaturedProducts = async (event, feature, param) => {
    event.preventDefault();

    history.push({
      pathname: `/products/${feature}`,

      state: {
        feature: feature,
      },
    });
  };

  return (
    <React.Fragment>
      <section className="pos-rel">
        <div className="ad-left" style={{ marginTop: 50 }}>
          <img src={Add} />
          {/* <AdComponent /> */}
        </div>
        <div className="ad-right" style={{ marginTop: 50 }}>
          <img src={Add} />
        </div>

        {!loadingCategories ? (
          categories &&
          categories.map((category) => {
            return (
              <div class="container" style={{ padding: 20 }}>
                {/* <div class="row"> */}
                <div class="col-md-12">
                  <div class="section-title-center ">
                    <h2 class="title">{category.name}</h2>
                  </div>
                </div>

                {getTrendingProduct(category, "Trending")}
              </div>
            );
          })
        ) : (
          <Loader text="Loading Categories" />
        )}

        {/* </div> */}
        <div class="ad-bottom">
          <img src={AddGif} />
        </div>
      </section>

      <section
        id="trending"
        class="pos-rel"
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <div class="ad-left">
          <img src={Add} />
        </div>
        <div class="ad-right">
          <img src={Add} />
        </div>
        <div class="container con-1040">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="section-title-center text-left">
                <h2 class="title pl-0">Price Center</h2>
              </div>
            </div>
            <div
              class="col-md-3 text-center "
              onClick={(e) => handlePriceCategory(e, 1, 5000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="img/price-center/1.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p>Less than Rs. 5000</p>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-3 text-center"
              onClick={(e) => handlePriceCategory(e, 5001, 10000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="img/price-center/2.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p>Rs. 5001 - Rs. 10,000</p>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-3 text-center"
              onClick={(e) => handlePriceCategory(e, 10000, 20000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="img/price-center/3.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p>Rs. 10,000 - Rs. 20,000</p>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-3 text-center "
              onClick={(e) => handlePriceCategory(e, 20000, 30000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="/img/price-center/4.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p>Rs. 20,000 - Rs. 30,000</p>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-3 text-center"
              onClick={(e) => handlePriceCategory(e, 30000, 40000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="/img/price-center/5.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p>Rs. 30,000 - Rs. 40,000</p>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-3 text-center"
              onClick={(e) => handlePriceCategory(e, 40000, 50000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="/img/price-center/6.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p>Rs. 40,000 - Rs. 50,000</p>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-3 text-center"
              onClick={(e) => handlePriceCategory(e, 50000, 20000000)}
            >
              <div class="price-card cursor-pointer">
                <div class="img-wrap">
                  <img src="img/price-center/7.jpg" />
                </div>
                <a href="">
                  <div class="cap font-weight-700">
                    <p> Above Rs. 50,000</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="ad-bottom">
          <img src={AddGif} />
        </div>
      </section>

      <section id="" class="compare-devices-sec">
        <div class="container pad-100-0">
          <div class="row mar-bot-100">
            <div class="col-md-12 text-center">
              <h1 class="col-wit font-weight-700 font-80 mar-bot-15">
                Compare your device here
              </h1>
              <p class="col-wit font-30">with any device in the world</p>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-4"
              style={{ display: "flex", justifyContent: "center", padding: 10 }}
            >
              <Search
                loading={productListLoading}
                index={0}
                onResultSelect={handleResultSelect}
                size="small"
                onSearchChange={handleSearchChange}
                className="device1"
                placeholder="device1"
                results={productList}
              />
              {/* <input type="text" name="" value="Device 1" /> */}
            </div>
            <div
              class="col-md-4"
              style={{ display: "flex", justifyContent: "center", padding: 10 }}
            >
              <Search
                loading={productListLoading}
                index={1}
                onResultSelect={handleResultSelect}
                size="small"
                onSearchChange={handleSearchChange}
                className="device1"
                placeholder="device2"
                results={productList}
              />
            </div>
            <div class="col-md-4">
              <button
                class="compare-go"
                onClick={() => comparehandlerMultiple(selectedProduct)}
              >
                Go <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section
        id=""
        class="trending-now-sec"
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <div class="container pad-100-0">
          <div class="row">
            <div class="col-md-12">
              <div class="section-title-center text-left">
                <h2 class="title pl-0">Trending Now</h2>
              </div>
            </div>

            <div
              class="col-md-6 col-lg-4 text-center cursor-pointer"
              onClick={(e) => getFeaturedProducts(e, "budgetPhone")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="/img/trending-colection.jpg" />
                </div>
                <a href="">
                  <div class="cap">
                    <h4 class="font-weight-500">Budget Phone</h4>
                  </div>
                </a>
              </div>
            </div>

            <div
              class="col-md-6 col-lg-4 text-center cursor-pointer"
              onClick={(e) => getFeaturedProducts(e, "camera")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/trending-now/3.jpg" />
                </div>
                <a href="">
                  <div class="cap">
                    <h4 class="font-weight-500">Best Camera Phone</h4>
                  </div>
                </a>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 text-center cursor-pointer">
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/ad-placeholder.jpg" />
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-4 text-center cursor-pointer"
              onClick={(e) => getFeaturedProducts(e, "bigScreen")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/trending-now/4.jpg" />
                </div>
                <a href="">
                  <div class="cap">
                    <h4 class="font-weight-500">Big Screen</h4>
                  </div>
                </a>
              </div>
            </div>

            <div
              class="col-md-6 col-lg-4 text-center cursor-pointer"
              onClick={(e) => getFeaturedProducts(e, "4g")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/trending-now/5.jpg" />
                </div>
                <a href="">
                  <div class="cap">
                    <h4 class="font-weight-500">4G Phone</h4>
                  </div>
                </a>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 text-center cursor-pointer">
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/ad-placeholder.jpg" />
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-4 text-center"
              onClick={(e) => getFeaturedProducts(e, "gaming")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/trending-colection.jpg" />
                </div>
                <a href="">
                  <div class="cap">
                    <h4 class="font-weight-500">Gaming</h4>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-4 text-center cursor-pointer"
              onClick={(e) => getFeaturedProducts(e, "comingSoon")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/trending-now/6.jpg" />
                </div>
                <a href="">
                  <div class="cap">
                    <h4 class="font-weight-500">Coming Soon</h4>
                  </div>
                </a>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-4 text-center cursor-pointer"
              onClick={(e) => getFeaturedProducts(e, "comingSoon")}
            >
              <div class="price-card">
                <div class="img-wrap">
                  <img src="img/ad-placeholder.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- =========================
        Trending Section
    ============================== --> */}
      <section id="trending" class="pos-rel home-feature-campare">
        <div class="ad-left">
          <img src="img/ad.png" />
        </div>
        <div class="ad-right">
          <img src="img/ad.png" />
        </div>
        {!compareLoading ? (
          <div class="container">
            {/* <div class="row"> */}
            <div class="col-md-12">
              <div class="section-title-center ">
                <h2 class="title">Featured Comparison</h2>
              </div>
            </div>

            {featuredProducts.map((product, index) => {
              return getFeaturedCompare(index);
            })}
          </div>
        ) : (
          <Loader text="Loading Featured comparison of Products" />
        )}

        {/* </div> */}
      </section>

      <section
        id="trending"
        class="home-feature-brand"
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <div class="container con-1040">
          <div class="row content-center">
            <div class="col-md-12">
              <div class="section-title-center">
                <h2 class="title">Featured Mobile Brands</h2>
              </div>
            </div>
          </div>
          <div class="row justify-content-center" style={{ cursor: "pointer" }}>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Nokia")}
            >
              <div class="img-wrap">
                <img src="img/brands/nokia.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Apple")}
            >
              <div class="img-wrap">
                <img src="img/brands/apple.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Samsung")}
            >
              <div class="img-wrap">
                <img src="img/brands/samsung.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Pixel")}
            >
              <div class="img-wrap">
                <img src="img/brands/pixel.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Motorola")}
            >
              <div class="img-wrap">
                <img src="img/brands/motorola.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Oppo")}
            >
              <div class="img-wrap">
                <img src="img/brands/oppo.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Huawei")}
            >
              <div class="img-wrap">
                <img src="img/brands/huawei.png" />
              </div>
            </div>
            <div
              class="col-3 col-sm-2"
              onClick={() => navigateCompanyProducts("Vivo")}
            >
              <div class="img-wrap">
                <img src="img/brands/vivo.png" />
              </div>
            </div>
          </div>
        </div>
        <ProductDetailsModal productModal={productModal} />
      </section>

      {/* <!-- =========================
      Footer Fullwidth social area
  ============================== --> */}
    </React.Fragment>
  );
};

export default Home;
